import Submit from '../../qualifyForm/pages/Submit'

export default function SnlConfirmation({ ...pageProps }) : JSX.Element {
  return (
    <div>
      <Submit isEmbedded={false} {...pageProps} />
    </div>
  )
}